module.exports = __webpack_public_path__ + "static/media/11.15c23c1c.jpg";